import BlRibbonAv from './BlRibbonAv.vue'

BlRibbonAv.install = function(Vue) {
  Vue.component(BlRibbonAv.name, BlRibbonAv)
}

export default BlRibbonAv
